import { Component, computed, OnInit, signal } from '@angular/core';
import { DyeingMachine, DyeingMachineStatus, getDyeingMachineStatus } from '@app/models/dyeing-dashboard/dyeing-machine';
import { DyeingMachineProxyService } from '@app/proxies/production/dyeing-machine.proxy.service';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';

@Component({
  selector: 'app-dyeing-machine-dashboard',
  templateUrl: './dyeing-machine-dashboard.component.html',
  styleUrl: './dyeing-machine-dashboard.component.scss',
})
export class DyeingMachineDashboardComponent implements OnInit {
  dyeingMachines = signal<DyeingMachine[]>([]);
  filteredDyeingMachines = signal<DyeingMachine[]>([]);
  currentSelection = signal<null | number>(null);
  isLoading = 0;
  DyeingMachineStatus = DyeingMachineStatus;

  machineStanByCount = computed(() => this.dyeingMachines().filter((m) => getDyeingMachineStatus(m) == DyeingMachineStatus.StandBy).length);
  machineRunningCount = computed(
    () => this.dyeingMachines().filter((m) => getDyeingMachineStatus(m) == DyeingMachineStatus.Running).length,
  );
  machineAwaitingQACount = computed(
    () => this.dyeingMachines().filter((m) => getDyeingMachineStatus(m) == DyeingMachineStatus.AwaitingQA).length,
  );
  machineUnloadingCount = computed(
    () => this.dyeingMachines().filter((m) => getDyeingMachineStatus(m) == DyeingMachineStatus.Unloading).length,
  );

  constructor(private readonly dyeingDashboardProxyService: DyeingMachineProxyService) {}

  ngOnInit(): void {
    this.getAllMachines();
  }

  private getAllMachines(): void {
    this.isLoading++;
    this.dyeingDashboardProxyService.getAllMachines().subscribe({
      next: ({ data }) => {
        if (data && data.length > 0) {
          this.isLoading--;
          const sorted = [...data].sort((a, b) => a.assetId.localeCompare(b.assetId, undefined, { numeric: true, sensitivity: 'base' }));
          this.dyeingMachines.set(sorted);
          this.filteredDyeingMachines.set(sorted);
        }
      },
      error: (error) => {
        this.isLoading--;
        console.log(error);
      },
    });
  }

  filteredMachine(option: number) {
    // Toggle off: if clicking the same option, clear selection and show all machines
    if (this.currentSelection() == option) {
      this.currentSelection.set(null);
      this.filteredDyeingMachines.set(this.dyeingMachines());
      return;
    }

    this.currentSelection.set(option);

    let statusToFilter: DyeingMachineStatus;
    switch (option) {
      case 1:
        statusToFilter = DyeingMachineStatus.StandBy;
        break;
      case 2:
        statusToFilter = DyeingMachineStatus.Running;
        break;
      case 3:
        statusToFilter = DyeingMachineStatus.AwaitingQA;
        break;
      case 4:
        statusToFilter = DyeingMachineStatus.Unloading;
        break;
      default:
        this.filteredDyeingMachines.set(this.dyeingMachines());
        return;
    }

    const filtered = this.dyeingMachines().filter((m) => getDyeingMachineStatus(m) === statusToFilter);
    this.filteredDyeingMachines.set(filtered);
  }

  filterByTerm(event: AutoCompleteCompleteEvent) {
    const term = event.query.trim().toLowerCase();

    if (term.length === 0) {
      this.currentSelection.set(null);
      this.filteredDyeingMachines.set(this.dyeingMachines());
      return;
    }

    this.currentSelection.set(null);

    const filtered = this.dyeingMachines().filter((m) => m.assetId.toLowerCase().includes(term));

    this.filteredDyeingMachines.set(filtered);
  }
}
